import * as Yup from 'yup';
import { WEB_URL_REGEX } from '../../../../utils/Constants';

export const orderEatCompanyStepValidation = (t) => {
  return {
    commercialName: Yup.string()
      .required(t('validationRequiredSpanish'))
      .min(2, t('validationMinLength', { amount: 2 }))
      .max(40, t('validationMaxLengthSpanish', { amount: 40 })),
    legalName: Yup.string()
      .required(t('validationRequiredSpanish'))
      .min(2, t('validationMinLength', { amount: 2 }))
      .max(40, t('validationMaxLengthSpanish', { amount: 40 })),
    rfc: Yup.string()
      .required(t('validationRequiredSpanish'))
      .min(8, t('validationMinLength', { amount: 8 }))
      .max(18, t('validationMaxLengthSpanish', { amount: 18 })),
    clabe: Yup.number()
      .required(t('validationRequiredSpanish'))
      .test('len', 'La CLABE debe ser de hasta 18 caracteres', (val) => {
        if (!val || !val.toString()) return false;
        return val.toString().length <= 18;
      }),
    fullAddress: Yup.string()
      .required(t('validationRequiredSpanish'))
      .min(2, t('validationMinLength', { amount: 2 }))
      .max(128, t('validationMaxLengthSpanish', { amount: 128 })),
    country: Yup.string().required(t('validationRequiredSpanish')),
    web: Yup.string().required(t('validationRequiredSpanish')).matches(WEB_URL_REGEX, t('validationUrl')),
    socialContract: Yup.mixed().required(t('validationRequiredSpanish')),
    organizationChart: Yup.mixed().required(t('validationRequiredSpanish')),
  };
};
